export const LoginLayout = {
  type: "div",
  style: {
    minHeight: "100svh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    // backgroundColor: "#ffffff"
  },
  children: [
    {
      type: "div",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: "url('/Shopback_Login_Photo.jpg')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        filter: "blur(1.5px)",
        zIndex: -1
      }
    },
    {
      type: "div",
      className: "row justify-content-center align-items-center",
      style: { flex: "1 0 auto", minHeight: 0, backgroundColor: "transparent", position: "relative", zIndex: 1 },
      children: [
        {
          type: "div",
          className: "p-5",
          style: {},
          children: [
            {
              type: "div",
              className: "text-center mb-5",
              style: { width: "100%" },
              children: [
                {
                  type: "img",
                  style: { width: "200px" },
                  altText: "client-logo"
                }
              ]
            },
            {
              type: "button",
              size: "large",
              htmlType: "submit",
              buttonType: "text",
              actionKey: "MSALLOGIN",
              className: "custom-color my-3",
              style: { backgroundColor: "$quaternary", color: "#ffffff", width: "100%" },
              children: [
                {
                  type: "text",
                  content: "{{LOGIN}}"
                }
              ]
            }
            // {
            //   type: "form",
            //   children: [
            //     {
            //       type: "input",
            //       isHide: "isNotLoginByUsername&&isNotLoginByLoginId",
            //       rules: [{ required: true, message: "{{PLEASE_ENTER_YOUR}} {{USERNAME}}" }],
            //       label: "{{USERNAME}}",
            //       name: "username",
            //       className: "",
            //       inputConfig: {
            //         placeholder: "{{ENTER}} {{USERNAME}}",
            //         suffix: {
            //           type: "icon",
            //           antIcon: "CheckCircleOutlined",
            //           style: { color: "#bbbbbb"}
            //         },
            //         className: "",
            //         size: "large"
            //       }
            //     },
            //     // {
            //     //   type: "input",
            //     //   isHide: "isNotLoginByMobileNumber",
            //     //   rules: [{ required: true, message: "{{PLEASE_ENTER_YOUR}} {{MOBILE_NUMBER}}" }],
            //     //   label:  "{{MOBILE_NUMBER}}",
            //     //   name: "username",
            //     //   className: "",
            //     //   inputConfig: {
            //     //     placeholder: "{{ENTER}} {{MOBILE_NUMBER}}",
            //     //     suffix: {
            //     //       type: "icon",
            //     //       antIcon: "CheckCircleOutlined",
            //     //       style: { color: "#bbbbbb"}
            //     //     },
            //     //     className: "",
            //     //     size: "large"
            //     //   }
            //     // },
            //     // {
            //     //   type: "input",
            //     //   variant: "password",
            //     //   rules:[{ required: true, message: "{{PLEASE_ENTER_YOUR}} {{PASSWORD}}" }],
            //     //   label: "{{PASSWORD}}",
            //     //   name: "password",
            //     //   className: "",
            //     //   inputConfig: {
            //     //     placeholder: "{{ENTER}} {{PASSWORD}}",
            //     //     className: "",
            //     //     size: "large"
            //     //   }
            //     // },
            //     {
            //       type: "input",
            //       rules: [{ required: true, message: "{{PLEASE_ENTER}} {{CAPTCHA}}" }],
            //       label: "{{VERIFICATION_CODE}} ",
            //       name: "captcha",
            //       className: "",
            //       inputConfig: {
            //         suffix: {
            //           type: "captcha",
            //           height: 39,
            //           width: 110,
            //           style: { borderRadius: 20, overflow: "hidden" },
            //           imageStyle: { height: 27, width: 80 },
            //           canRefresh: true
            //         },
            //         className: "",
            //         size: "large"
            //       }
            //     },

            // ]
            //  },
            //{
            // type: "div",
            // className: "my-4",
            //   children: [
            // {
            //  type: "text",
            //  content: "<div class=\"text-center\"><a style=\"color: $quaternary;\" href=\"#/forgot-password\">{{FORGOT_PASSWORD}}?</a></div>"
            //  },
            // {
            //   type: "text",
            //   content: {
            //     en: "<div class=\"text-center\" style=\"color: #ffffff;\">Not A Member? <a style=\"color: $quaternary;\" href=\"#/register\">Sign Up Now</a></div>"
            //   }
            // }
            // ]
            // }
          ]
        }
      ]
    },
    {
      type: "footer",
      style: { height: "40px", backgroundColor: "transparent" }
    }
  ]
}